module.exports = __webpack_public_path__ + "static/img/全部.b5e2fa81.png";